import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, GET_SUPPLY_CHAINS } from './api'
import { Data, SupplyChainSliceDTO, Variables } from './api/types'
import { SupplyChainForTable, UseGetSupplyChains, UseGetSupplyChainsProps } from './types'

export const useGetSupplyChains = ({
  filters,
  first,
  last,
  sort,
}: UseGetSupplyChainsProps): UseGetSupplyChains => {
  const { workspaceId } = useWorkspaceParam()
  const [supplyChains, setSupplyChains] = useState<SupplyChainForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        supplyChains: { nodes: supplyChains, totalCount: count },
      } = data

      if (supplyChains) {
        setSupplyChains(
          supplyChains.map(
            (supplyChain: SupplyChainSliceDTO): SupplyChainForTable => fromDTO(supplyChain),
          ),
        )
      }

      setCount(count)
    },
    query: GET_SUPPLY_CHAINS,
    variables: {
      first,
      last,
      sort,
      terms: filters,
      workspaceId,
    },
  })

  return {
    count,
    loading: isLoading,
    supplyChains,
  }
}
